import type { Dispatch } from 'redux';
import { connect } from '@atlassian/jira-react-redux';
import ValidationError from '@atlassian/jira-servicedesk-automation-common/src/view/common/validation-error/view.tsx';
import { copyRuleAction } from '../../../../state/actions/rule/copy';
import { setShowDeleteDialogAction } from '../../../../state/actions/rule/delete';
import { viewLogAction } from '../../../../state/actions/rule/view-log';
import {
	getRuleName,
	maybeRuleDescription,
	getEditRuleUrl,
	isRuleEnabled,
	getValidationErrorMessages,
} from '../../../../state/selectors/rulesets';
import type { State } from '../../../../state/types';
import ActionsMenu from './actions-menu/view.tsx';
import DeleteDialog from './delete-dialog';
import Rule, { type Props } from './view';

const mapStateToProps = (state: State, ownProps: Partial<Props>) => ({
	// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
	name: getRuleName(state, ownProps.ruleSetId),
	// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
	description: maybeRuleDescription(state, ownProps.ruleSetId).orSome(''),
	// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
	disabled: !isRuleEnabled(state, ownProps.ruleSetId),
	// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
	url: getEditRuleUrl(state, ownProps.ruleSetId),
	// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
	validationErrorMessages: getValidationErrorMessages(state, ownProps.ruleSetId),
	ActionsMenuComponent: ActionsMenu,
	DeleteDialogComponent: DeleteDialog,
	ValidationErrorComponent: ValidationError,
});

const mapDispatchToProps = (dispatch: Dispatch, ownProps: Partial<Props>) => ({
	// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string | null'.
	onOpenDelete: () => dispatch(setShowDeleteDialogAction(ownProps.ruleSetId)),
	// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
	onDuplicate: () => dispatch(copyRuleAction(ownProps.ruleSetId)),
	// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
	onViewLog: () => dispatch(viewLogAction(ownProps.ruleSetId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Rule);
